export default function page() {
    return (
        <div>
            <h1>404,当前页面不存在</h1>
        </div>
    )
}
